<template>
    <v-container fluid style="margin: 60px 15%">
      <vueHeadful
      :title="this.$i18n.t('Menu.Alianzas') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row>
            <v-col cols="12" align="center"  style="margin-bottom:60px">
                <h1 :style="responsiveTitulo" class="titulo">{{$t('Menu.Alianzas')}}</h1>
            </v-col>
            <v-form ref="form" v-model="valido" style="width:-webkit-fill-available!important;">
              <v-col cols="12">
                  <v-text-field solo v-model="formulario.nombre" :label="$t('Formularios.Nombre')" :hint="$t('Formularios.Nombre')" :rules="[v => !!v || $t('Formularios.NombreRequerido')]" persistent-hint />
              </v-col>
              <v-col cols="12">
                  <v-text-field solo v-model="formulario.empresa" :label="$t('Formularios.Empresa')" :hint="$t('Formularios.Empresa')" :rules="[v => !!v || $t('Formularios.CampoRequerido')]" persistent-hint />
              </v-col>
              <v-col cols="12">
                  <v-text-field solo v-model="formulario.telefono" :label="$t('Formularios.Telefono')" :hint="$t('Formularios.Telefono')" :rules="[v => !!v || $t('Formularios.TelefonoRequerido')]" persistent-hint />
              </v-col>
              <v-col cols="12">
                  <v-text-field solo v-model="formulario.correo" :label="$t('Formularios.Email')" :hint="$t('Formularios.Email')" :rules="[v => !!v || $t('Formularios.EmailRequerido')]" persistent-hint />
              </v-col>
              <v-col cols="12">
                  <v-autocomplete solo :items="getPaises" item-text="name" item-value="id" v-model="formulario.pais" :label="$t('Formularios.Pais')" :hint="$t('Formularios.Pais')" :rules="[v => !!v || $t('Formularios.PaisRequerido')]" persistent-hint />
              </v-col>
              <v-col cols="12" v-if="formulario.pais">
                  <v-autocomplete solo :items="Object.keys(getPaises[formulario.pais - 1].states)" v-model="formulario.departamento" :label="$t('Formularios.Departamento')" :hint="$t('Formularios.Departamento')" :rules="[v => !!v || $t('Formularios.DepartamentoRequerido')]" persistent-hint />
              </v-col>
              <v-col cols="12" v-if="formulario.departamento">
                <v-text-field class="mx-2" solo persistent-hint v-model="formulario.ciudad" :label="$t('Formularios.Ciudad')" :hint="$t('Formularios.Ciudad')" :rules="[v => !!v || $t('Formularios.CiudadRequerido')]"/>
              </v-col>
              <v-col cols="12">
                  <v-textarea solo v-model="formulario.descripcion" :label="$t('Formularios.CualEsTuPropuesta')" :hint="$t('Formularios.CualEsTuPropuesta')" :rules="[v => !!v || $t('Formularios.CampoRequerido')]" persistent-hint />
              </v-col>
              <v-col cols="12" align="center">
                  <v-btn color="black white--text" x-large style="min-width:20%!important" @click="recaptcha()" :disabled="!valido">{{$t('Formularios.EnviarInformacion')}}</v-btn>
              </v-col>
            </v-form>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as faker from 'faker'
import axios from 'axios'
export default {
  name: 'Alianzas',
  data () {
    return {
      valido: false,
      formulario: {
        uid: faker.random.alphaNumeric(8).toUpperCase(),
        nombre: null,
        empresa: null,
        pais: null,
        departamento: null,
        ciudad: null,
        correo: null,
        telefono: null,
        descripcion: null
      }
    }
  },
  computed: {
    ...mapGetters(['getPaises']),
    responsiveTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:2rem;line-height:2rem;'
        case 'sm': return 'font-size:3rem;line-height:3rem;'
        case 'md': return 'font-size:3rem;line-height:3rem;'
        case 'lg': return 'font-size:4rem;line-height:4rem;'
        case 'xl': return 'font-size:4rem;line-height:4rem;'
        default: return 'font-size:4rem;line-height:4rem;'
      }
    }
  },
  methods: {
    ...mapMutations(['setAlerta', 'setTextoAlerta']),
    ...mapActions(['enviarCorreo']),
    async recaptcha () {
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('formulario')
      this.token = token
      const proxyurl = 'https://cors-anywhere.herokuapp.com/'
      axios.post(proxyurl + `https://www.google.com/recaptcha/api/siteverify?secret=6Lecxt8UAAAAAMGvH7DsPe0HbI7MREdSQVzCVOP1&response=${token}`)
        .then(res => {
          if (res.data.success) {
            this.solicitar()
          } else {
            this.setAlerta()
            this.setTextoAlerta('Alerta.EresRobot')
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    solicitar () {
      this.enviarCorreo({
        destino: 'soycliente@trartist.com',
        asunto: this.$i18n.t('Formularios.AsuntoAlianzas', { uid: this.formulario.uid, nombre: this.formulario.nombre }),
        texto: this.$i18n.t('Formularios.TextoAlianzas', {
          uid: this.formulario.uid,
          nombre: this.formulario.nombre,
          empresa: this.formulario.empresa,
          pais: this.getPaises[this.formulario.pais - 1].name,
          departamento: this.formulario.departamento,
          ciudad: this.formulario.ciudad,
          telefono: this.formulario.telefono,
          correo: this.formulario.correo,
          descripcion: this.formulario.descripcion
        })
      })
      this.formulario = {
        uid: faker.random.alphaNumeric(8).toUpperCase(),
        nombre: null,
        empresa: null,
        pais: null,
        departamento: null,
        ciudad: null,
        correo: null,
        telefono: null,
        descripcion: null
      }
    }
  }
}
</script>

<style>
.titulo {
  font-family: 'Be Vietnam', sans-serif!important;
  font-weight: 600!important;
}
</style>
